// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"CoverVideo_videoContainer__HMiR4","video":"CoverVideo_video__6xP44","popout":"CoverVideo_popout__j6QBt","chatToggle":"CoverVideo_chatToggle__pcmVl"};